<div class="loading-contianer">
    <ng-lottie *ngIf="true"   containerClass="mx-auto" [options]="{path: 'assets/animations/loading-animation.json', autoplay: true, loop:true}" width="300px"
    height="300px"></ng-lottie>
    <p>{{message}}</p>
</div>